var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('div',{staticClass:"txt"},[_vm._v("正在前往微信支付中...")])])
}]

export { render, staticRenderFns }